import axios from 'axios'

export class SecurityInterceptor {
  _requestInterceptor = null
  _responseInterceptor = null

  $store = null
  $router = null

  constructor ({ store, router, i18n }) {
    this.$store = store
    this.$router = router
    this.$i18n = i18n
  }
  attachRequestInterceptor () {
    this._requestInterceptor = axios.interceptors.request.use(
      config => {
        config = this.setRequestHeaders(config)
        return config
      },
      error => {
        return Promise.reject(error)
      }
    )
  }
  attachResponseInterceptor () {
    this._responseInterceptor = axios.interceptors.response.use(
      response => {
        return response
      },
      async error => {
        const originalRequest = error.config
        let errorResponse = error.response
        if (!originalRequest.skipAuthErrorInterceptor) {
          if (errorResponse.status === 401) {
            this.detachResponseInterceptor()
            try {
              if (!this.getCredentials().refreshToken) {
                throw error
              }
              await this.$store.dispatch('entities/users/refreshToken', this.getCredentials())
              this.attachResponseInterceptor()
              this.setRequestHeaders(originalRequest)
              return await axios(originalRequest)
            } catch (err) {
              this.attachResponseInterceptor()
              await this.destroyToken()
              this.$router.push({ name: 'login' })
              throw error
            }
          } else if (errorResponse.status === 403) {
            if (errorResponse.data && errorResponse.data.data && errorResponse.data.data.code === 'ERR_PWD_EXPIRED') {
              const email = this.$store.getters['entities/users/email']
              await this.destroyToken()
              this.$router.push({ name: 'login.expired', params: { email: email } })
            } else {
              console.log('Error : Not allowed')
            }
          }
        }
        throw error
      }
    )
  }
  hasCredentials () {
    return window.localStorage.keepEmail && window.localStorage.keepEmail !== '' &&
      window.localStorage.keepPassword && window.localStorage.keepPassword !== ''
  }
  getCredentials () {
    return {
      refreshToken: window.localStorage.refreshToken
    }
  }
  detachRequestInterceptor () {
    axios.interceptors.response.eject(this._requestInterceptor)
  }
  detachResponseInterceptor () {
    axios.interceptors.response.eject(this._responseInterceptor)
  }
  setRequestHeaders (config) {
    const token = localStorage.accessToken
    if (token) {
      const type = localStorage.tokenType || 'Bearer'
      config.headers['Authorization'] = `${type} ${token}`
    }
    config.headers['Content-type'] = 'application/json'
    config.headers['X-Requested-With'] = 'XMLHttpRequest'
    // TODO: check if have any lang saved in localStorage, if not browser lang or default
    config.headers['Accept-Language'] = 'en'
    return config
  }
  async destroyToken () {
    try {
      await this.$store.dispatch('entities/users/logout')
    } catch (error) {
      console.error(error)
    }
  }
}
